module.exports = __webpack_public_path__ + "img/mm.b94a5983.jpg";